import type { Optional } from '@festina-life/core'
import type { ReactNode } from 'react'

import { TreeContent } from './TreeContent'
import { TreeContextProvider } from './TreeContextProvider'
import type { TreeLeafData, TreeNodeData } from './types'

type Props<Leaf extends TreeLeafData> = {
  nodes: TreeNodeData<Leaf>[]
  renderLeaf: (leaf: Leaf) => ReactNode
  renderTags?: (attributes: string[]) => ReactNode
  renderNode?: (node: TreeNodeData<Leaf>) => ReactNode
  renderNodeActions?: (node: TreeNodeData<TreeLeafData>) => ReactNode
  renderLeafActions?: (node: Leaf) => ReactNode
  containerRef?: Optional<HTMLElement>
  id: string
  nodeClassName?: Optional<
    string | ((node: TreeNodeData<Leaf>) => Optional<string>)
  >
  leafClassName?: Optional<string | ((leaf: Leaf) => Optional<string>)>
  query?: Optional<string>
  onSelectNode?: (node: TreeNodeData<Leaf>) => void
  onSelectLeaf?: (leaf: Leaf) => void
  shouldSortNodes?: boolean
  isVisible?: boolean
}

export const Tree = <Leaf extends TreeLeafData>({
  id,
  nodes,
  renderLeaf,
  containerRef,
  leafClassName,
  nodeClassName,
  ...other
}: Props<Leaf>) => (
  <TreeContextProvider
    id={id}
    trees={nodes}
    renderLeaf={renderLeaf}
    containerRef={containerRef}
    leafClassName={
      leafClassName as Optional<string | ((leaf: TreeLeafData) => string)>
    }
    nodeClassName={
      nodeClassName as Optional<
        string | ((leaf: TreeNodeData<TreeLeafData>) => string)
      >
    }
    {...other}
  >
    <TreeContent />
  </TreeContextProvider>
)
